export enum EApertureIndex
{
    Bottom = 0,
    Top = 1
}